import DataType from '@opsbase/lib-datatype/DataType';
import i18n from '@opsbase/lib-i18n';
import Pages from '@opsbase/lib-pages';
import useSelf from '@opsbase/react-ctrl-self/useSelf';
import useAppState from '@opsbase/web-app-state/useAppState';
import useAppStateActions from '@opsbase/web-app-state/useAppStateActions';
import AppPage from '@opsbase/web-app/AppPage';
import DVLPage from '@opsbase/web-dvl-page';
import Horizontal from '@opsbase/web-layout/Horizontal';
import Pane from '@opsbase/web-layout/Pane';
import Vertical from '@opsbase/web-layout/Vertical';
import useNav from '@opsbase/web-nav/useNav';
import useParams from '@opsbase/web-nav/useParams';
import SidePane from '@opsbase/web-ui/SidePane/SidePane';
import React from 'react';
import ReportsList from '../../shared/UX/ReportsList/ReportsList';
import ReportsTabs from '../../shared/UX/ReportsList/ReportsTabs';
import IssueMenu from '../menus/IssueMenu';
import IssuesSelectionToolbar from '../toolbars/IssuesSelectionToolbar';
export function AnalyticsIssuesPage() {
    let { viewId } = useParams();
    const dataType = DataType.ISSUE;
    const { manageReportsOpen } = useAppState();
    const { setManageReportsOpen } = useAppStateActions();
    const { settings } = useSelf();
    const { replaceTo } = useNav();
    if (viewId === 'default') {
        replaceTo(Pages.ISSUES_LOG, { viewId: settings === null || settings === void 0 ? void 0 : settings.defaultIssuesLogLmssId });
        return null;
    }
    return (React.createElement(AppPage, null,
        React.createElement(Horizontal, { style: { overflow: 'hidden' } },
            React.createElement(SidePane, { startOpen: manageReportsOpen, left: true, padding: true, width: 300, label: i18n.t('manage-savedviews'), renderOpen: () => React.createElement(ReportsList, { viewId: viewId, dataType: dataType }), onChangeOpen: setManageReportsOpen }),
            React.createElement(Vertical, { style: { overflow: 'hidden' } },
                React.createElement(Pane, null,
                    React.createElement(ReportsTabs, { dataType: dataType })),
                React.createElement(DVLPage, { key: "issueslog", viewId: viewId, itemPage: Pages.ISSUES_VIEW, itemMenu: IssueMenu, notFoundText: i18n.t('no-issues-found'), itemSelectionToolbar: React.createElement(IssuesSelectionToolbar, null) })))));
}
export default AnalyticsIssuesPage;
